import { createStore } from 'vuex'
import busDevice from './busDevice'
import product from './product'
import app from './app'

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    busDevice,
    app,
    product
  }
})
